// extracted by mini-css-extract-plugin
export default {"TrixContainer":"uhGEipBfpTP6ICAou4e6","TrixContent":"aVuIzn_2EeNKfGkZ4_Y9","Invalid":"L_7etIEFB8kdennCM2Ar","attachment__progress":"vUZfG0Qe5h9IXLcIH5N2"};